exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth.actions {\n  width: 240px;\n}\nth.th-title {\n  text-align: center;\n}\nth.guid {\n  min-width: 210px;\n  text-align: center;\n}\nth.activity_type {\n  min-width: 160px;\n  text-align: center;\n}\n.dropdown-menu {\n  max-height: 400px;\n  overflow-y: auto;\n}\n", ""]);

// exports
